import React, { useState, useEffect } from 'react';
import { useParams, withRouter } from 'react-router-dom';
import { Layout, Row, Col, Form, Input, Spin, Space, message } from 'antd';
import HeaderComp from '../../shared/components/header/header';
import HandShake from '../../assets/images/activate/handshake.png';
import SadFace from '../../assets/images/activate/sad-face.png';
import Activate from '../../assets/images/activate/Roxus_Icons_Individual_Tick.png';
import GraButton from '../../shared/components/button/gra-button';
import axiosConfig from '../../shared/utils/axios-config';
import PasswordChecklist from "react-password-checklist"
import { delay } from '../../shared/helpers/helpers';
import './forgot-password.scss';

const ForgotPasswordPage = ({ history }) => {

    const params = useParams();

    const [loading, setLoading] = useState(false);
    const [validateCode, setValidateCode] = useState({});
    const [email, setEmail] = useState("");

    const onFinish = async (values) => {
        

        setLoading(true);

        try {
            console.log(values);
            await axiosConfig({
                method: 'post',
                data: values,
                url: `/api/nanonets/users/forgot-password`,
            })
                .then((response) => {
                    console.log("Setup Password response", response);
                    message.success("An email containing a link to reset the password is sent to the email.")
                    setLoading(false);
                    delay(3000);
                    history.push("/login")
                })
                .catch((error) => {
                    message.error("Account does not exist. Please use a different email.")
                    setLoading(false);
                });
        }
        catch (ex) {

        }
        finally {
            setLoading(false);
        }

    };

    const validateActivationCode = async () => {
        setLoading(true);
        await axiosConfig({
            method: 'post',
            url: `/api/nanonets/validate/${params.activationCode}`,
        })
            .then((response) => {
                console.log("Validate Response", JSON.stringify(response));
                setValidateCode(response.data.data);
                delay(1000);
                setLoading(false);
            })
            .catch((error) => {
                setValidateCode(null);
                setLoading(false);
            });
    };

    useEffect(() => {
        console.log("Activation Code", params.activationCode);
        validateActivationCode();
    }, [params]);

    return (
        <Layout>
            <HeaderComp />
            <Spin spinning={loading}>
                <Layout className='activate-page'>
                    <Row justify='center' align='middle' className='content'>
                        <Col>
                            <img src={Activate} width={200} alt='' />{' '}
                        </Col>
                        <Col offset={1}>
                            <div>
                                <span className='activate-status'>
                                    Hi {validateCode?.firstName}
                                </span>
                            </div>
                            <div className='mt-md'>
                                <span>
                                    Enter your registered email address to change your Contxtus account password.
                                </span>
                            </div>
                            <Form
                                name='email-form'
                                className='login-form mt-md'
                                initialValues={{
                                    remember: true,
                                }}
                                onFinish={onFinish}
                            >
                                <Form.Item
                                    name='email'
                                    rules={[
                                        {
                                            type: 'email',
                                            message: 'The input is not valid E-mail!',
                                          },
                                          {
                                            required: true,
                                            message: 'Please input your E-mail!',
                                          },
                                    ]}
                                    onChange={e => setEmail(e.target.value)}
                                >
                                    <Input size='large' type='email' placeholder='Input your email' />
                                </Form.Item>
                                <div className='mt-md'>
                                    <GraButton className='button-gra-inv' type='submit'>
                                        CONFIRM
                                    </GraButton>
                                </div>
                            </Form>
                        </Col>
                    </Row>
                </Layout>
            </Spin>
        </Layout>
    );
};

export default withRouter(ForgotPasswordPage);